exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".floating-box[data-v-06bb5833]{width:auto;padding:1rem;background:#fff;box-shadow:0 3px 10px 2px rgba(0,0,0,.1);border-radius:5px;max-width:none}img[data-v-06bb5833]{margin:0 auto}.social-combo[data-v-06bb5833]{display:flex;flex-wrap:wrap;justify-content:center}@media print,screen and (min-width:40em){.social-combo[data-v-06bb5833]{margin:1rem auto;margin-top:0;width:calc(100% - 4rem)}}@media screen and (max-width:39.9375em){.social-combo[data-v-06bb5833]{margin-bottom:1rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-06bb5833","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/shared/donate-banner.vue
// module id = 111
// module chunks = 4